import styled from 'styled-components';

interface DropdownMenuProps {
    top?: number;
    left?: number;
    width?: number;
    direction?: 'up' | 'down';
}

export const DropdownContainer = styled.div`
  position: relative;
  display: inline-block;
  z-index: 0;
`;

export const DropdownButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease;
  z-index: 10;

  &:hover {
    background-color: #f5f5f5;
  }
`;

export const DropdownMenu = styled.div<DropdownMenuProps>`
  position: fixed;
  top: ${({ top }) => (typeof top === 'number' ? `${top}px` : 'unset')};
  left: ${({ left }) => (typeof left === 'number' ? `${left}px` : 'unset')};
  width: ${({ width }) => (typeof width === 'number' ? `${width}px` : 'auto')};
  background-color: white;
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
  z-index: 2147483647;
  min-width: 200px;
  padding: 8px 0;
  white-space: nowrap;
  max-height: 400px;
  overflow-y: auto;
  animation: ${({ direction }) => direction === 'up' ? 'slideUp' : 'slideDown'} 0.18s cubic-bezier(.4,0,.2,1);

  @keyframes slideDown {
    from { opacity: 0; transform: translateY(-10px); }
    to { opacity: 1; transform: translateY(0); }
  }
  @keyframes slideUp {
    from { opacity: 0; transform: translateY(10px); }
    to { opacity: 1; transform: translateY(0); }
  }
`;

export const DropdownItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 16px;
  cursor: pointer;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  color: #303030;
  transition: background-color 0.2s ease;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &:hover {
    background-color: #f5f5f5;
  }

  svg {
    color: #666666;
    flex-shrink: 0;
  }
`;
